import React from "react";
import OwlCarousel from "react-owl-carousel";

export default function TestimonialTwo({ hasBg }) {
  const options = {
    loop: false,
    margin: 30,
    items: 1,
    nav: true,
    dots: false,
    responsiveClass: true,
    autoplay: false,
    autoplayHoverPause: true,
    lazyLoad: true,
  };
  return (
    <>
      <section
        className={`testimonial-section py-5 ${hasBg ? "gray-light-bg " : ""}`}
      >
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6">
              <div className="section-heading mb-5">
                <h2>What Clients Say About Us</h2>
                <p className="lead">
                  Wonderful interactive group game to play on any social or
                  corporate gathering. Finally, something to look forward to
                  beyond trivia nights! Strategy element is cool. It took a
                  moment to completely understand, but once you get it, playing
                  mind games with your peers is super fun!
                </p>

                <div className="client-section-wrap d-flex flex-row align-items-center">
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <img
                        src="assets/img/client-1-color.png"
                        width="85"
                        alt="client"
                        className="img-fluid"
                      />
                    </li>
                    <li className="list-inline-item">
                      <img
                        src="assets/img/client-6-color.png"
                        width="85"
                        alt="client"
                        className="img-fluid"
                      />
                    </li>
                    <li className="list-inline-item">
                      <img
                        src="assets/img/client-3-color.png"
                        width="85"
                        alt="client"
                        className="img-fluid"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <OwlCarousel
                className="owl-carousel owl-theme client-testimonial arrow-indicator"
                {...options}
              >
                <div className="item">
                  <div className="testimonial-quote-wrap">
                    <div className="media author-info mb-3">
                      <div className="author-img mr-3">
                        <img
                          src="assets/img/client-1.jpg"
                          alt="client"
                          className="img-fluid rounded-circle"
                        />
                      </div>
                      <div className="media-body">
                        <h5 className="mb-0">John Charles</h5>
                        <span>App Store</span>
                      </div>
                    </div>
                    <div className="client-say">
                      <p>
                        <img
                          src="assets/img/quote.png"
                          alt="quote"
                          className="img-fluid"
                        />
                        I had a great experience overall. Questions were super
                        fun and thoughtful. A unique way of psychologically
                        competing with others. Absolute best feature is that you
                        can change your answer anytime!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-quote-wrap">
                    <div className="media author-info mb-3">
                      <div className="author-img mr-3">
                        <img
                          src="assets/img/client-2.jpg"
                          alt="client"
                          className="img-fluid rounded-circle"
                        />
                      </div>
                      <div className="media-body">
                        <h5 className="mb-0">Arabella Ora</h5>
                        <span>Play Store</span>
                      </div>
                    </div>
                    <div className="client-say">
                      <p>
                        <img
                          src="assets/img/quote.png"
                          alt="quote"
                          className="img-fluid"
                        />
                        Wao! Real winnings in such a cool format. I could
                        honestly nail it every single time. Feels the same for
                        others too. Awesome platform to win real money. Way
                        better than fantasy apps for me.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-quote-wrap">
                    <div className="media author-info mb-3">
                      <div className="author-img mr-3">
                        <img
                          src="assets/img/client-1.jpg"
                          alt="client"
                          className="img-fluid rounded-circle"
                        />
                      </div>
                      <div className="media-body">
                        <h5 className="mb-0">Jeremy Jere</h5>
                        <span>Themetags</span>
                      </div>
                    </div>
                    <div className="client-say">
                      <p>
                        <img
                          src="assets/img/quote.png"
                          alt="quote"
                          className="img-fluid"
                        />
                        Objectively synthesize client-centered e-tailers for
                        maintainable channels. Holisticly administrate customer
                        directed vortals whereas tactical functionalities.
                        Energistically monetize reliable imperatives through
                        client-centric best practices. Collaboratively.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-quote-wrap">
                    <div className="media author-info mb-3">
                      <div className="author-img mr-3">
                        <img
                          src="assets/img/client-1.jpg"
                          alt="client"
                          className="img-fluid rounded-circle"
                        />
                      </div>
                      <div className="media-body">
                        <h5 className="mb-0">John Charles</h5>
                        <span>Google</span>
                      </div>
                    </div>
                    <div className="client-say">
                      <p>
                        <img
                          src="assets/img/quote.png"
                          alt="quote"
                          className="img-fluid"
                        />
                        Enthusiastically innovate B2C data without
                        clicks-and-mortar convergence. Monotonectally deliver
                        compelling testing procedures vis-a-vis B2B testing
                        procedures. Competently evisculate integrated resources
                        whereas global processes. Enthusiastically.
                      </p>
                    </div>
                  </div>
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
